var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.67188 0.5 0 3.19531 0 6.5C0 9.82812 2.67188 12.5 6 12.5C9.30469 12.5 12 9.82812 12 6.5C12 3.19531 9.30469 0.5 6 0.5ZM6 11.75C3.09375 11.75 0.75 9.40625 0.75 6.5C0.75 3.61719 3.09375 1.25 6 1.25C8.88281 1.25 11.25 3.61719 11.25 6.5C11.25 9.40625 8.88281 11.75 6 11.75Z",
    fill: "#E0E1E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeselected);
export default __webpack_public_path__ + "static/media/deselected.4a8799fdf27667047663998f174d79a9.svg";
export { ForwardRef as ReactComponent };